import React  from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()
const Register = () => {
    let history = useHistory();
    const handleSubmit = async e => {
      history.push("/shops/login");
    };
    const mainHeader = {
        width: "100%",
        maxWidth: "100%",
        height: "150vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      };
      
      const forms = {
        width: "564px",
        height: "1100px",
        padding: "62px 48px",
        border: "1px solid #c2c2c2",
        borderRadius: "15px",
        textAlign: "start",
        fontFamily: "'Noto Sans', sans-serif",
        fontSize: "14px",
        marginBottom: "17px",
        color: "#212121"
      };
      const center2 = {
        display: "block",
        paddingTop: "20px",
        marginLeft: "auto",
        marginRight: "auto",
        paddingBottom: '20px'
      }
      const center = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto"
      }
      const btnOrange = {
        backgroundColor: "#f54336",
        width: "100%",
        color: "#fff",
        borderRadius: "30px",
        marginTop: "10px",
        marginBottom: "10px",
        fontSize: "13px"
      };
      
      const h2 = {
        display: "block",
        paddingBottom: "45px",
        marginBottom: "17px",
        color: "#212121"
      };
      const formGroup = {
        marginBottom: "10px"
      };
      
      const formControl = {
        paddingTop: "30px",
        paddingLeft: "0",
        paddingBottom: "30px",
        outline: "none",
        border: "none",
        borderBottom: "1px solid #e0e2e6",
        borderRadius: "0px",
        marginTop: "10px",
        "&::focus": {
          borderBottom: "1px solid #f54336",
          outline: "none",
          boxShadow: "none"
        }
      };
      
    return(
    <div>
        <img src={process.env.PUBLIC_URL + "/images/logo_new.png"} width="220" height="110" alt="logo" style={center2}/>
        <header id="main-header" style={mainHeader}>
          <div className="form" style={forms}>
            <form action="#" className="was-validated">
              <div className="form-group" style={formGroup}>
                <h2 style={h2}>Register</h2>
              </div>
              <div className="form-group" style={formGroup}>
                <input
                  placeholder="Shop Name"
                  id="name"
                  className="form-control"
                  style={formControl}
                  type="text"
                />
              </div>
              <div className="form-group" style={formGroup}>
                <input
                  id="detail"
                  placeholder="Shop Detail"
                  className="form-control"
                  style={formControl}
                  type="text"
                />
              </div>
              <div className="form-group" style={formGroup}>
                <input
                  placeholder="Location"
                  id="location"
                  className="form-control"
                  style={formControl}
                  type="text"
                />
              </div>
              <div className="form-group" style={formGroup}>
                  <label type="label"><h6>Opening Time : </h6></label>
                  <select className="btn btn-success" style={center}>
                    <option value="09:00:00" defaultChecked>9:00 AM</option>
                    <option value="10:00:00">10:00 AM</option>
                    <option value="11:00:00">11:00 AM</option>
                    <option value="12:00:00">12:00 PM</option>
                    <option value="13:00:00">1:00 PM</option>
                    <option value="14:00:00">2:00 PM</option>
                    <option value="15:00:00">3:00 PM</option>
                    <option value="16:00:00">4:00 PM</option>
                    <option value="17:00:00">5:00 PM</option>
                  </select>
              </div>
              <div className="form-group" style={formGroup}>
                <label type="label"><h6>Closing Time : </h6></label>
                  <select className="btn btn-warning" style={center}>
                    <option value="20:00:00" defaultChecked>8:00 PM</option>
                    <option value="19:00:00">7:00 PM</option>
                    <option value="18:00:00">6:00 PM</option>
                    <option value="17:00:00">5:00 PM</option>
                    <option value="16:00:00">4:00 PM</option>
                    <option value="15:00:00">3:00 PM</option>
                    <option value="14:00:00">2:00 PM</option>
                    <option value="13:00:00">1:00 PM</option>
                    <option value="12:00:00">12:00 AM</option>
                  </select>
              </div>
              <div className="form-group" style={formGroup}>
                <input
                  type="text"
                  placeholder="Your Gst (For Verification)" 
                  id="gst"
                  className="form-control"
                  style={formControl}
                />
              </div>
              <div className="form-group" style={formGroup}>
                <label htmlfor="servicetime"><h6>Service time:(Avg time for a customer(like packing): </h6></label>
                <input type="time" id="servicetime" className="form-control" style={formControl} />
              </div>
              <div className="form-group" style={formGroup}>
                <input
                  type="text"
                  placeholder="No of customer allowed in 1 hr"
                  id="slot"
                  className="form-control"
                  style={formControl}
                />
              </div>
    
              <div className="form-group" style={formGroup}>
                <input
                  type="password"
                  placeholder="Password"
                  id="password"
                  className="form-control"
                  style={formControl}
                />
              </div>
    
              <div className="form-group" style={formGroup}>
                <input
                  type="password"
                  placeholder="Confirm Password"
                  id="password2"
                  className="form-control"
                  style={formControl}
                />
              </div>
              <div className="form-group" style={formGroup}>
                <button
                  className="btn btn-lg btn-orange"
                  style={btnOrange}
                  onClick={handleSubmit}
                >
                  Register
                </button>
              </div>
              <div className="form-group" style={formGroup}></div>
              <div className="form-group" style={formGroup}>
                <p className="">
                  Already have an account?
                  <a href="/CloudCart-Preview/#/shops/login">
                    {" "}
                    Login
                  </a>
                </p>
              </div>
            </form>
          </div>
        </header>
      </div>
    );
};
export default Register;